// extracted by mini-css-extract-plugin
export default {"overlay":"fy-z","bodyOpen":"gy-z","content":"hy-z","header":"iy-z","close":"jy-z","closeNoHeading":"ky-z"};